/* eslint-disable no-control-regex */
export const filterAllowedUnicodeCharsRegex = new RegExp(
  /[^\u0020-\u00ff\u000a^\t]/gm,
);
